/* SYNCED from shotbook-landing/src/components/ui/Button.tsx — не править руками, запускать npm run sync:ds */
import type { AnchorHTMLAttributes, ButtonHTMLAttributes } from 'react';
import { cx } from '@/lib/cx';
import styles from './Button.module.css';

export type ButtonVariant = 'primary' | 'ghost' | 'quiet' | 'control';
export type ButtonSize = 'lg' | 'md' | 'sm' | 'plan';

type SharedProps = {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Растягивает кнопку по ширине контейнера. */
  block?: boolean;
  className?: string;
};

function classNames({ variant = 'primary', size = 'md', block, className }: SharedProps): string {
  return cx(styles.base, styles[variant], styles[size], block && styles.block, className);
}

export type ButtonLinkProps = SharedProps & AnchorHTMLAttributes<HTMLAnchorElement>;

/** Ссылка-кнопка. Переходы в /app/ — обычный <a>, Next их не перехватывает. */
export function ButtonLink({ variant, size, block, className, ...rest }: ButtonLinkProps) {
  return <a className={classNames({ variant, size, block, className })} {...rest} />;
}

export type ButtonProps = SharedProps & ButtonHTMLAttributes<HTMLButtonElement>;

export function Button({ variant, size, block, className, type = 'button', ...rest }: ButtonProps) {
  return (
    <button type={type} className={classNames({ variant, size, block, className })} {...rest} />
  );
}
